import React from 'react';
import { Alert } from 'reactstrap';

export default class NotAuthenticated extends React.Component {
    render() {
        return (
            <Alert color="danger">403 Forbidden or No Permission to Access</Alert>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NotAuthenticated.js